import{getAugmentedNamespace as o}from"./_commonjsHelpers.js";import*as s from"../node_modules/focus-trap/dist/focus-trap.esm.js";var r=o(s);export{r as default};
